import type { MessageDescriptor } from "@lingui/core";
import { defineMessage as dm } from "@lingui/core/macro";

import type { ProjectType } from "./types";

export type ProjectColumnId =
  | "id"
  | "expectedDate"
  | "clientLabel"
  | "mainAccountantLabel"
  | "label"
  | "type"
  | "serviceGroupLabel"
  | "stateLabel"
  | "statusLabel"
  | "estimatedMinutes"
  | "estimatedPrice"
  | "validatedMinutes"
  | "amountToBill"
  | "billedPrice"
  | "billedHourPrice"
  | "balance"
  | "actions";

export type ProjectListView = {
  id: string;
  label: MessageDescriptor;
  type: ProjectType | "all";
  columns: ProjectColumnId[];
};

export const PROJECT_LIST_VIEWS: ProjectListView[] = [
  {
    id: "projects",
    label: dm`Projects`,
    type: "all",
    columns: [
      "id",
      "clientLabel",
      "label",
      "mainAccountantLabel",
      "type",
      "serviceGroupLabel",
      "statusLabel",
      "actions",
    ],
  },
  {
    id: "subscriptions",
    label: dm`Subscriptions`,
    type: "subscription",
    columns: [
      "id",
      "clientLabel",
      "label",
      "mainAccountantLabel",
      "serviceGroupLabel",
      "statusLabel",
      "actions",
    ],
  },
  {
    id: "subscription-billing",
    label: dm`Subscriptions, billing`,
    type: "subscription",
    columns: [
      "id",
      "clientLabel",
      "label",
      "mainAccountantLabel",
      "statusLabel",
      "billedPrice",
      "billedHourPrice",
      "balance",
      "actions",
    ],
  },
  {
    id: "interventions",
    label: dm`Interventions`,
    type: "intervention",
    columns: [
      "id",
      "expectedDate",
      "clientLabel",
      "label",
      "mainAccountantLabel",
      "stateLabel",
      "statusLabel",
      "estimatedMinutes",
      "estimatedPrice",
      "actions",
    ],
  },
  {
    id: "intervention-to-bill",
    label: dm`Interventions, to bill`,
    type: "intervention",
    columns: [
      "id",
      "expectedDate",
      "clientLabel",
      "label",
      "mainAccountantLabel",
      "statusLabel",
      "validatedMinutes",
      "amountToBill",
      "actions",
    ],
  },
  {
    id: "intervention-billed",
    label: dm`Interventions, billed`,
    type: "intervention",
    columns: [
      "id",
      "expectedDate",
      "clientLabel",
      "label",
      "mainAccountantLabel",
      "statusLabel",
      "validatedMinutes",
      "billedPrice",
      "billedHourPrice",
      "balance",
      "actions",
    ],
  },
];

export function projectListViews(type: ProjectType | "all"): ProjectListView[] {
  const views = PROJECT_LIST_VIEWS.filter((view) => view.type === type);

  return 0 === views.length
    ? PROJECT_LIST_VIEWS.filter((view) => "all" === view.type)
    : views;
}
